var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsolation1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3201 104.065L30.26 172.556L125.25 233.185V161.535L77.7901 78.1549L30.3301 104.075L30.3201 104.065Z",
    fill: "#B2E8C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.39 118.235C221.88 137.765 222.37 157.295 222.88 176.825L125.25 233.175V161.525C127.86 160.345 170.68 141.075 173.32 139.885C175.93 138.705 218.76 119.425 221.4 118.235H221.39Z",
    fill: "#72D09A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.78 95.6651C18.63 98.4551 24.47 101.275 30.32 104.065L77.78 78.1451C99.04 108.865 120.27 139.575 141.53 170.295C173.43 152.985 205.32 135.685 237.22 118.375C216.05 84.5251 194.89 50.6651 173.72 16.8151C141.74 30.9651 109.76 45.1151 77.78 59.2651C56.11 71.4051 34.44 83.5451 12.78 95.6551V95.6651Z",
    fill: "#FECECA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.78 95.6655L30.32 104.066L77.78 78.1455L125.24 161.526L141.53 170.296L77.78 59.2955L12.78 95.6655Z",
    fill: "#FEE4E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3201 104.065L125.25 161.525L77.7901 78.1451L30.3301 104.065H30.3201Z",
    fill: "#A7CFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3201 104.065L125.25 161.525C109.12 132.795 92.9801 104.055 76.8501 75.3151C61.3401 84.8951 45.8301 94.4751 30.3301 104.055L30.3201 104.065Z",
    fill: "#F97E73"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9799 97.6853C22.7599 99.8153 26.5399 101.945 30.3199 104.065C45.8299 94.4853 61.34 84.9053 76.84 75.3253C92.97 104.055 109.11 132.795 125.24 161.535L141.53 170.305L77.78 59.3053L18.97 97.6953L18.9799 97.6853Z",
    fill: "#FEE4E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsolation1);
export default __webpack_public_path__ + "static/media/isolation1.359fd63ac6eb6175eef06d66ef2c93c3.svg";
export { ForwardRef as ReactComponent };